import Cookies from 'universal-cookie'

const cookies = new Cookies()
let cookieConfig = {}
let cookieDomain = ''

if (cookieConfig !== '') {
  cookieConfig = {
    domain: cookieDomain,
    path: '/',
    toggle: {}
  }
}

export function saveCookie (name, value) {
  cookies.set(name, value, cookieConfig)
}

export function getCookie (name) {
  return cookies.get(name)
}

export function removeCookie (name) {
  cookies.remove(name, { path: '/' })
}
